import React from 'react';
import { Box } from '@mui/material';
import {TextFieldWithHeader} from "../textField/TextFieldWithHeader";

interface ColorInputProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
}

export const ColorInput: React.FC<ColorInputProps> = ({ label, value, onChange }) => {
    return (
        <Box display="flex" alignItems="end" gap={1} mb={2}>
            <TextFieldWithHeader
                header={label}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                fullWidth
                inputProps={{maxLength: 7}}
            />
            <input
                type="color"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                style={{
                    width: 56,
                    height: 56,
                    border: 'none',
                    background: 'transparent',
                    padding: 0,
                    cursor: 'pointer',
                }}
            />
        </Box>
    );
};